import React, { FC } from "react";
import styled from "styled-components";

const DisclaimerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 0.875rem;
  font-weight: 400;
  color: ${({ theme }) => theme.bodyColor};
  background-color: #c57f16;
  padding: 10px 20px;
`;
const ExclamationMark = styled.span`
  display: inline-block;
  color: inherit;
  font-weight: bold;
  font-size: 1.2rem;
`;

interface Props {
  children: React.ReactNode;
}

export const Disclaimer: FC<Props> = ({ children }) => (
  <DisclaimerContainer>
    <ExclamationMark>!</ExclamationMark>
    {children}
  </DisclaimerContainer>
);
